module.exports = __webpack_public_path__ + "img/edit-active.23709f80.svg";